import Steps from 'rc-steps';
import 'rc-steps/assets/index.css';
import 'rc-steps/assets/iconfont.css';
import './Steps.scss';

export default Steps;



// WEBPACK FOOTER //
// ./webpack/components/Modules/Steps/Steps.js